/**
 * @fileoverview Renders styled buttons from received props in a styled wrapper
 */
import React from 'react'
import { RosterViewLinksWrapper } from '../Campaigns/RosterView/RosterViewLinksWrapper'
import SubmitButton from 'Components/Form/SubmitButton'

/**
 * Returns generated react component that contains rendered buttons with labels and actions assigned to them
 *
 * @param {array<Object>} props.items Array of button's data that we want to render
 * @param {string} props.items[].label Name of the path that will be displayed to the user
 * @param {string} props.items[].action Functionn that will be called on click
 *
 * @returns JSX.Element
 *
 * @example
 *  <ActionLinks
 *    items={[{ label:'Publish', action: () => {} }]}
 *  />
 */
const ActionLinks = ({ items }) => {
  const renderItems = items.map(({ label, action }, index) => (
    <SubmitButton
      key={`ActionLinks-LinkPublish-${label}-${index}`}
      value={label}
      onClick={action}
    />
  ))
  return <RosterViewLinksWrapper>{renderItems}</RosterViewLinksWrapper>
}

export default ActionLinks
